export enum ManagerAuthorization {
    accountRequestReviewAddEdit = 'accountRequestReviewAddEdit',
    adminProcessEdit = 'adminProcessEdit',
    adminProcessRead = 'adminProcessRead',
    adminsAddEdit = 'adminsAddEdit',
    adminsRead = 'adminsRead',
    chatbotSso = 'chatbotSso',
    contractFundingDataAddEdit = 'contractFundingDataAddEdit',
    dermaAppRegistrationLogs = 'dermaAppRegistrationLogs',
    desktopProcessesLog = 'desktopProcessesLog',
    deviceAndAccessoryTypes = 'deviceAndAccessoryTypes',
    devicesAddEdit = 'devicesAddEdit',
    devicesRead = 'devicesRead',
    embloomQuestionnaires = 'embloomQuestionnaires',
    employmentFinanceData = 'employmentFinanceData',
    employmentRelationNumberEdit = 'employmentRelationNumberEdit',
    employmentSettingsEdit = 'employmentSettingsEdit',
    employmentSettingsRead = 'employmentSettingsRead',
    employmentsOld = 'employmentsOld',
    exportDeclarationRecords = 'exportDeclarationRecords',
    exportDesktopTest = 'exportDesktopTest',
    exportFundusFiles = 'exportFundusFiles',
    exportInvoiceRecords = 'exportInvoiceRecords',
    exportPatientQuestionnaires = 'exportPatientQuestionnaires',
    exportPayoutRecords = 'exportPayoutRecords',
    exportUbd = 'exportUbd',
    failedProcessWorkflowStepRerun = 'failedProcessWorkflowStepRerun',
    featureFlag = 'featureFlag',
    financeFunding = 'financeFunding',
    financePayoutsEdit = 'financePayoutsEdit',
    financePayoutsRead = 'financePayoutsRead',
    fundingLogRead = 'fundingLogRead',
    fundusScreeningManualImport = 'fundusScreeningManualImport',
    graderPools = 'graderPools',
    groupAddEdit = 'groupAddEdit',
    groupEditFinanceData = 'groupEditFinanceData',
    groupRead = 'groupRead',
    groupReadFinanceData = 'groupReadFinanceData',
    importBankAccounts = 'importBankAccounts',
    importDhd = 'importDhd',
    importExactRelationData = 'importExactRelationData',
    importHardwareTokens = 'importHardwareTokens',
    importNoShows = 'importNoShows',
    insurersAddEdit = 'insurersAddEdit',
    insurersRead = 'insurersRead',
    jobs = 'jobs',
    managerAuthorizations = 'managerAuthorizations',
    organizationAddEdit = 'organizationAddEdit',
    organizationFinanceData = 'organizationFinanceData',
    organizationRead = 'organizationRead',
    organizationRelationNumberEdit = 'organizationRelationNumberEdit',
    patientAccessLog = 'patientAccessLog',
    patientDataRequests = 'patientDataRequests',
    patientEdit = 'patientEdit',
    patientInsurance = 'patientInsurance',
    patientProcesses = 'patientProcesses',
    patientReadBasic = 'patientReadBasic',
    patientReadContactData = 'patientReadContactData',
    practitionerAddEdit = 'practitionerAddEdit',
    practitionerRead = 'practitionerRead',
    reportFinancialComplete = 'reportFinancialComplete',
    reportFunding = 'reportFunding',
    reportPayouts = 'reportPayouts',
    serviceAddEdit = 'serviceAddEdit',
    serviceDeclarationRules = 'serviceDeclarationRules',
    serviceRightsCareproviders = 'serviceRightsCareproviders',
    serviceRightsGroups = 'serviceRightsGroups',
    serviceRightsOrganizations = 'serviceRightsOrganizations',
    servicesRead = 'servicesRead',
    thirdPartyIncomingMessages = 'thirdPartyIncomingMessages',
    thirdPartyMessages = 'thirdPartyMessages',
    updateProcessWorkflowStepsAndActivities = 'updateProcessWorkflowStepsAndActivities',
    uzovisAddEdit = 'uzovisAddEdit',
    uzovisRead = 'uzovisRead',
}
